import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
const mergeResourceBundles = (fallbackResources = {}, primaryResources = {}) => {
    const merged = Object.assign({}, fallbackResources);
    Object.entries(primaryResources).forEach(([namespace, resources]) => {
        var _a;
        merged[namespace] = Object.assign(Object.assign({}, ((_a = merged[namespace]) !== null && _a !== void 0 ? _a : {})), resources);
    });
    return merged;
};
const addResourceBundles = (language, resources = {}, overwrite = false) => {
    Object.keys(resources).forEach((ns) => {
        i18n.addResourceBundle(language, ns, resources[ns], true, overwrite);
    });
};
export const initI18n = (initialLng = 'en', resources = {}, namespaces = [], jsonFiles = {}) => {
    const initialLanguageResources = mergeResourceBundles(jsonFiles === null || jsonFiles === void 0 ? void 0 : jsonFiles[initialLng], resources);
    if (!i18n.isInitialized) {
        i18n
            .use(LanguageDetector)
            .use(initReactI18next)
            .init({
            lng: initialLng,
            fallbackLng: {
                'fr-CA': ['fr', 'en'],
                fr: ['en'],
                en: ['fr', 'en'],
                default: ['fr', 'en'],
            },
            interpolation: {
                escapeValue: false,
            },
            resources: Object.assign(Object.assign({}, (jsonFiles !== null && jsonFiles !== void 0 ? jsonFiles : {})), { [initialLng]: initialLanguageResources }),
            ns: namespaces,
            defaultNS: 'common',
            nsSeparator: '|',
            react: {
                useSuspense: false,
            },
        });
    }
    else {
        if (initialLng !== i18n.language) {
            i18n.changeLanguage(initialLng);
        }
        if (!!(jsonFiles === null || jsonFiles === void 0 ? void 0 : jsonFiles['en'])) {
            addResourceBundles('en', jsonFiles['en']);
        }
        if (!!(jsonFiles === null || jsonFiles === void 0 ? void 0 : jsonFiles['fr'])) {
            addResourceBundles('fr', jsonFiles['fr']);
        }
        addResourceBundles(initialLng, resources, true);
        i18n.reloadResources();
    }
    return i18n;
};
